<template>
  <div class="apply-result">
    <div class="result-body">
      <img :src="checkIco" alt="" class="result-ico" />
      <div class="result-title">{{ checkTitle }}</div>
      <div class="check-desc" v-if="status == 0">
        <p>信息提交成功！我们将在1-3个工作日内审核完成,请耐心等待</p>
        <p>
          审核结果,我们将通过短信通知您。
          <template 
            ><span>如有疑问可点击咨询</span>
            <span class="service-link" @click="onService"> 在线客服 </span>
          </template>
        </p>
      </div>
      <div class="check-desc" v-if="status == 2">
        <p>
          {{ reason }}
        </p>
        <p>
          <template 
            ><span>如有疑问可点击咨询</span>
            <span class="service-link" @click="onService"> 在线客服 </span>
          </template>
        </p>
      </div>
      <div class="flex justify-center">
        <div class="return-btn" @click="$router.replace({ name: 'Index' })">
          返回首页
        </div>
        <div class="return-btn margin-left-20" @click="reApply" v-if="status == 2">重新申请</div>
      </div>
    </div>
    <chat ref="chat"></chat>
  </div>
</template>
<script>
import { RegisterCheck } from "@/api/procurement";
export default {
  data() {
    return {
      type: "",
      status: 0,
      reason: "",
    };
  },
  computed: {
    checkIco() {
      const { type,status } = this;
      if (type == 'apply' || status == 1) {
				return require("@/assets/images/procurement/icon-apply-success.png");
			} else{
        return require("@/assets/images/procurement/icon-apply-checking.png");
      }
      
    },
    checkTitle() {
      if (this.status == 0) {
        return "面辅料代购员入驻申请信息提交成功!";
      }
      if (this.status == 2) {
        return "审核不通过";
      }
      return "已成功入驻";
    },
  },
  mounted() {
   
    const { type } = this.$route.query;
    if(type){
      this.type = type;
    }
    this.onCheck();
  },
  methods: {
    async reApply() {
      this.$router.push({ name: "ProcurementRegister" });
    },
    async onCheck() {
      const { code, data } = await RegisterCheck();
      this.status = data.status;
      this.reason = data.reason;
    },
    onService() {
      this.$refs["chat"].showChat();
    },
  },
};
</script>
<style lang="scss" scoped>
.apply-result {
  width: 100%;
  min-height: 100vh;
  background: #f5f9fc;
  display: flex;
  justify-content: center;
  .result-body {
    width: 100%;
    max-width: 1000px;
    height: 776px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 8px 4px rgba(1, 32, 55, 0.05);
    margin-top: 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .result-ico {
      width: 182px;
      height: 98px;
      margin-top: 108px;
    }
    .result-title {
      font-weight: bold;
      font-size: 26px;
      color: #02c160;
      margin-top: 47px;
    }
    .check-desc {
      color: #666;
      font-size: 14px;
      text-align: center;
      margin-top: 16px;
      .service-link {
        cursor: pointer;
        color: #0d99ff;
      }
    }
    .return-btn {
      width: 120px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border-radius: 4px;
      border: 1px solid #e3e3e3;
      cursor: pointer;
      color: #333;
      font-size: 14px;
      margin-top: 76px;
    }
  }
}
</style>
